import {lazy} from 'react';

import {ReportAccessGuard, useImporterReportingIntegrations} from '@dms/shared-aftersales';

const Reports = lazy(() => import('./components/Reports'));

export function MercedesMraReport() {
  const {isMercedesMraEnabled, isLoading, isError} = useImporterReportingIntegrations();

  return (
    <ReportAccessGuard
      hasAccess={isMercedesMraEnabled}
      isLoading={isLoading}
      isError={isError}
      data-testid="mercedesMraReport"
    >
      <Reports />
    </ReportAccessGuard>
  );
}
